import HttpService from 'domovio-core/src/system/rest/rest.service';

export async function loadCatalogues(projectId) {
    return HttpService.get('/v1/catalogue', { projectId });
}

export async function loadCatalogue(catalogueId) {
    return HttpService.get('/v1/catalogue/' + catalogueId);
}

export async function loadCatalogueColumnDefinitions() {
    return HttpService.get('/v1/catalogue/column/definitions');
}

export async function loadCatalogueFilterDefinitions() {
    return HttpService.get('/v1/catalogue/filter/definitions');
}

export async function loadCatalogueProjectColumnSet(setId) {
    return HttpService.get('/v1/catalogue/column/sets/' + setId);
}

export async function loadCatalogueProjectFilterSet(setId) {
    return HttpService.get('/v1/catalogue/filter/sets/' + setId);
}

export async function saveCatalogueProjectColumnDefinitions(data) {
    return HttpService.post('/v1/catalogue/column/project-definitions/bulk', data);
}

export async function saveCatalogueProjectFilterDefinitions(data) {
    return HttpService.post('/v1/catalogue/filter/project-definitions/bulk', data);
}
